

export function error(message?: any, ...optionalParams: any[]) {
    console.error("BUGS: ", message, optionalParams);
}